import React, { useCallback, useState } from "react";
import { AddCrossTinyIcon, Body2, IconButton, List, ListItem, MinusIcon } from "@activecollab/components";
import PropTypes from "prop-types";
import "./TextVariablesList.less";

export const TextVariablesList = ({ textVariable, handleSelectVariable }) => {
  const [variables, setVariables] = useState(textVariable?.map((v) => ({ ...v, count: 0 })));

  const handleCountChange = useCallback((e, index, countChange) => {
    e.stopPropagation();
    setVariables((prevState) =>
      prevState.map((prev, i) => {
        if (i === index) {
          return {
            ...prev,
            count: prev.count + countChange,
          };
        }
        return prev;
      })
    );
  }, []);

  const resolveCount = useCallback(
    (v) => (v?.count === 0 ? `{${v?.name}}` : v?.count > 0 ? `{${v?.name}+${v.count}}` : `{${v?.name}${v.count}}`),
    []
  );

  const renderIncrementButton = (index, value) => {
    return (
      <IconButton
        variant="text gray"
        size="small"
        onClick={(e) => handleCountChange(e, index, value)}
        className="text-variable-modifier"
      >
        {value < 0 ? <MinusIcon /> : <AddCrossTinyIcon />}
      </IconButton>
    );
  };

  return (
    <div className="tw-max-h-[220px] tw-overflow-y-auto">
      <List className="tw-flex tw-flex-col tw-gap-1 tw-pt-1">
        {variables?.map((v, index) => (
          <ListItem
            key={`${v.name}-${index}`}
            className="tw-flex-row tw-h-7 tw-justify-between tw-pr-3 tw-my-0 text-variable"
            onClick={() => handleSelectVariable(resolveCount(v))}
          >
            <Body2
              color="primary"
              weight="regular"
              className="tw-truncate"
            >
              {v?.description}
            </Body2>

            <div className="tw-flex tw-flex-row tw-items-center tw-shrink-0">
              {renderIncrementButton(index, -1)}
              <Body2
                className="tw-px-1"
                color="primary"
                weight="regular"
              >
                {resolveCount(v)}
              </Body2>
              {renderIncrementButton(index, 1)}
            </div>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

TextVariablesList.propTypes = {
  textVariable: PropTypes.array,
  handleSelectVariable: PropTypes.func,
};
